import { ITrainWidgetNotificationPayload } from '@/models/Train/interfaces/ITrainWidgetNotificationPayload';
import { ITrainWidgetNotificationRequestParams } from '@/models/Train/interfaces/ITrainWidgetNotificationRequestParams';
import debug from 'debug';

import { BaseActions } from '../Common/Actions/BaseActions';
import { execAction } from '../Common/Actions/handler';
import { ResponseEither } from '../Common/ResponseEither';
import TrainRequestBuilder from './TrainRequestBuilder';

const log = debug('sunny:TrainActions');

export default class TrainActions extends BaseActions<TrainRequestBuilder> {
  // KTX 알림 메세지
  widgetNotification(
    params: ITrainWidgetNotificationRequestParams,
  ): Promise<ResponseEither<ITrainWidgetNotificationPayload>> {
    log('widgetNotification');
    return execAction('widget notification', this.requestBuilder.createGetWidgetNotification(params));
  }
}
